<div class="d-flex justify-content-center">
  <h3 mat-dialog-title>
    <i class="fa-solid fa-circle-exclamation"></i>
    {{ data.title }}
  </h3>
</div>
@if (data.message.length > 0) {
  <mat-dialog-content>
    <p [innerHTML]="data.message + '<br>' + data.subMessage"></p>
  </mat-dialog-content>
}
<mat-dialog-actions class="justify-content-center">
  @if (useDefault) {
    <div class="d-flex flex-column gap-4 gap-sm-2 align-items-center justify-content-evenly">
      <wfs-form-button
        (buttonClicked)="triggerEvent(false)"
        [label]="data.denyText"
        [buttonStyle]="data.buttonStyles['deny']" />
    </div>
  } @else {
    <div
      class="d-flex flex-column gap-4 gap-sm-2 align-items-center justify-content-evenly"
      [class.flex-row]="!revertButtons"
      [class.flex-row-reverse]="revertButtons">
      <wfs-form-button
        (buttonClicked)="triggerEvent(true)"
        [label]="data.confirmText"
        [buttonStyle]="data.buttonStyles['confirm']" />
      <wfs-form-button
        (buttonClicked)="triggerEvent(false)"
        [label]="data.denyText"
        [buttonStyle]="data.buttonStyles['deny']" />
    </div>
  }
</mat-dialog-actions>
